import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "../../../button";
import { Icon } from "../../../icon";
export const ToggleCollapseButton = ({ isOpen, toggleOpen, }) => {
    return (_jsx(Button, { onClick: () => toggleOpen(!isOpen), type: "link", style: {
            marginBottom: "24px",
            marginTop: "16px",
        }, children: _jsx(Icon, { name: isOpen ? "up" : "down" }) }));
};
